import React, {useState} from 'react';
import '../App.css'


const Todo = (props) => {
    const[value, setValue] = useState();

    const onChangeText = (e) => {
        setValue(e.target.value)
        console.log(e)
    }


//    props.itemtodo.domanda
    return (
        <div>      

           <div>
              
            {props.itemtodo.domanda.map(function(itemtododomanda,index2) {
//                console.log(itemtododomanda)
//                console.log('' + props.index + '' + props.indice_video)
                if (props.index===props.video_scelto.indice) {
                    var tempo = itemtododomanda.tempocorrente/60
                    console.log('formtodo.js entrato');
                    { 
                        return <div className= "out_formtodo_js"> 
                       
                        <input type="text" value={itemtododomanda.value} placeholder = "Aggiungi memo" onChange={onChangeText} />

                        <button onClick={() => props.function_set_tempo_seek(itemtododomanda.tempocorrente)} > {tempo.toFixed(2)} </button>
                        </div>
                    }
                }
                else
                {

                }
                })
            }          
           
           </div>
       </div>
       

    )

  }

export default Todo;
